"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authReducer = void 0;
var _reduxActions = require("redux-actions");
var _immutable = require("immutable");
var _actions = require("./actions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = (0, _immutable.Map)({
  otpusk: (0, _immutable.Map)({
    token: {
      access_token: null
    },
    lang: null
  }),
  theme: {
    button: {
      background: '#8c4a91'
    },
    primaryColor: '#8c4a91'
  },
  /**
  * @param {{ defaultDepartureID: number }} session description
  */
  session: {}
});
var authReducer = exports.authReducer = (0, _reduxActions.handleActions)(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _actions.authActions.setLang, function (state, _ref) {
  var lang = _ref.payload;
  return state.setIn(['otpusk', 'lang'], lang);
}), _actions.authActions.setApiKey, function (state, _ref2) {
  var key = _ref2.payload;
  return state.setIn(['otpusk', 'token', 'access_token'], key);
}), _actions.authActions.setTheme, function (state, _ref3) {
  var theme = _ref3.payload;
  return state.set('theme', theme);
}), _actions.authActions.setSession, function (state, _ref4) {
  var session = _ref4.payload;
  return state.set('session', session);
}), initialState, {
  prefix: 'tourscaner'
});